import { deleteRequest, get, post, postfd, publicPost, put } from "../helpers/apihelpers";

export const CreateOpinionFileService=async(data)=>{
    try {
        const result = await post(`api/opinion_file/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateOpinionFileService=async(data,id)=>{
    try {
        const result = await put(`api/opinion_file/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadOpinionFileFile=async(data)=>{
    try {
        const result = await postfd(`api/opinion_file/upload_file`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetOpinionFileService=async(page,search,from_date,to_date,type,step=1)=>{
    try {
        const result = await get(`api/opinion_file/get?page=${page}&search=${search}&from_date=${from_date}to_date=${to_date}&type=${type}&step=${step}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetOpinionFileDetailService=async(id)=>{
    try {
        const result = await get(`api/opinion_file/get/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const DeleteOpinionFileService=async(id)=>{
    try {
        const result = await deleteRequest(`api/opinion_file/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}